import { useTranslation } from "react-i18next";

import { Col, Divider, Row } from "antd";
import { InputNumber, Select, Switch } from "components/form";

import { ACTION } from "features/payment/schemas/PaymentShemas";
import styles from "../styles/Attendance.module.css";

const ShiftsOtherSettingForm = ({
  values = {},
  attendanceConditionOptions = [],
}) => {
  const { t } = useTranslation();
  let disabledContent = values?.type === ACTION.VIEW ? true : false;
  return (
    <>
      <Row justify="space-between" style={{ paddingTop: "24px" }}>
        <b className={styles.infoTopic}>{t('attendance.attendance-policy')}</b>
      </Row>
      <Divider />
      <Row gutter={[24, 16]}>
        <Col span={12}>
          <Select
            name="attendanceConditionId"
            label={
              t("shift.label.attendance_condition")
            }
            placeholder={
              t("shift.placeholders.attendance_condition") +
              t("common.required_field_suffix")
            }
            size="large"
            options={attendanceConditionOptions}
            disabled={disabledContent}
            required
          />
        </Col>
        <Col span={6}>
          <p style={{ marginBottom: "8px" }}>
            {t("shift.label.allow_flexible_work_in_status")}
          </p>
          <Switch name="allowFlexibleWorkInStatus" label="" disabled={disabledContent} />
        </Col>
        {values.allowFlexibleWorkInStatus ? (
          <Col span={12}>
            <InputNumber
              name="allowFlexibleWorkIn"
              label={t("shift.label.allow_flexible_work_in")}
              placeholder={t('minutes')}
              size="large"
              step={10}
              textAlign="left"
              disabled={disabledContent}
            />
          </Col>
        ) : (
          <></>
        )}
      </Row>
    </>
  );
};

export default ShiftsOtherSettingForm;
